class BankMovementCell extends BankEntryCell
{
    private amountLabel:MUILabel = null;
    private pillView:MUIView = null;
    private pillLabel:MUILabel = null;

    awakeFromHTML(){
        super.awakeFromHTML();

        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
        this.pillView = MUIOutlet(this, "pill-view", "MUIView");
        this.pillLabel = MUIOutlet(this, "pill-lbl", "MUILabel");
    }

    setItem(item:BankMovement){
        super.setItem(item);

        this.amountLabel.text = BankMovementState.signedAmountString(item.amount);
        if (item.amount > 0) MUICoreLayerAddStyle(this.amountLabel.layer, "positive");
        else MUICoreLayerRemoveStyle(this.amountLabel.layer, "positive");

        // The analytic account in the movement's status colour: red while uncategorized, yellow
        // while it misses documents, green once complete
        let status = BankMovementState.statusOf(item);
        let statuses = [BankMovementStatus.Uncategorized, BankMovementStatus.MissingDocuments, BankMovementStatus.Complete];
        for (let index = 0; index < statuses.length; index++){
            if (statuses[index] == status) MUICoreLayerAddStyle(this.pillView.layer, statuses[index]);
            else MUICoreLayerRemoveStyle(this.pillView.layer, statuses[index]);
        }

        this.pillLabel.text = status == BankMovementStatus.Uncategorized
            ? MIOLocalizeString("UNCATEGORIZED", "Uncategorized")
            : BankMovementState.analyticAccountTitle(item);
    }
}
